import initialState from './../../initialState';

export default (state = initialState.achados, { type, value, response }) => {
  switch (type) {
    case 'LIST_ACHADOS_REQUEST':
      return {
        ...state,
        fetching: 1,
        errors: []
      };
    case 'LIST_ACHADOS_SUCCESS':
      return {
        ...state,
        fetching: 2,
        updated_at: new Date(),
        ...response
      };
    case 'LIST_ACHADOS_FAILURE':
      return {
        ...state,
        fetching: 0
      };
    case 'ATUALIZA_ITEM_ACHADOS_FAILURE':
      return {
        ...state,
        fetching: 0
      };
    case 'ATUALIZA_ITEM_ACHADOS_REQUEST':
      return {
        ...state,
        fetching: 1
      };
    case 'ATUALIZA_ITEM_ACHADOS_SUCCESS':
      if (response.result) {
        return {
          ...state,
          fetching: 2,
          result: state.result.map(v => {
            if (v.id === response.result.id) {
              return {
                ...v,
                ...response.result
              };
            }
            return v;
          })
        };
      };
      return {
        ...state,
        fetching: 2,
      };
  case 'SELECT_HISTORICO_ITEM_ACHADOS_SUCCESS':
      return {
        ...state,
        result: state.result.map(v => {
          if (v === value) {
            v.historico = response.result;
          }
          return v;
        })
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/achados/reducer.js